import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ContactModalProvider } from './contexts/ContactModalContext';
import App from './App';

const AppWrapper = () => {
  return (
    <Router>
      <AuthProvider>
        <ContactModalProvider>
          <App />
        </ContactModalProvider>
      </AuthProvider>
    </Router>
  );
};

export default AppWrapper;
